import Parse, { cloudFunction } from 'services/parse';

export async function uploadFile(base64, type?: string): Promise<Parse.File> {
  const file = new Parse.File('document', { base64 }, type);
  await file.save();
  return file;
}

export const searchUserByName = (data: Record<string, any>) => {
  return cloudFunction('searchUserByName', data);
};

export const reverseGeoCode = async ({ lat: latitude, lng: longitude }) => {
  return await cloudFunction('reverseGeoCode', {
    coords: { latitude, longitude },
  });
};

export const removePaymentMethodForUser = async (
  userId: string,
  paymentMethodId: string,
) => {
  return await cloudFunction('removePaymentMethodForUser', {
    userId,
    paymentMethodId,
  });
};

export const fetchPaymentMethodsForUser = async (userId: string) => {
  return await cloudFunction('fetchPaymentMethodsForUser', { userId });
};

export const processHomeBoxOrders = async () => {
  return await cloudFunction('processHomeBoxOrders', {});
};

export const sendPendingOrderDeliveryEmail = async () => {
  return await cloudFunction('sendPendingOrderDeliveryEmail', {});
};

export const fetchAllCities = async () => {
  const response = await cloudFunction('fetchAllCities', {});
  return response.map((row) => row.city);
};
